import { useSelector } from 'react-redux';
import { Form } from 'formik';
import FormikTextField from 'components/FormikFields/FormikTextField';
import LockIcon from '@material-ui/icons/Lock';
import CheckIcon from '@material-ui/icons/Check';
import { useStep2Styles } from './styles';
import { FormattedPhone } from '../../../../Shared/FormattedPhone';

const Step2UserDetails = ({ values, backendErrors }) => {
  const classes = useStep2Styles();
  const { en: { forms } } = useSelector((state) => state.i18n);
  const { createUserFlow } = useSelector((state) => state.userAccountManagement);


  return (
    <div className={classes.container}>
      <h3 className={classes.title}>
        {forms?.step2UserDetails || 'Step 2: User Details'}
      </h3>
      <p className={classes.subtitle}>
        {forms?.enterUserInformation || 'Enter the user\'s personal information'}
      </p>

      <Form>
        <div className={classes.section}>
          {/* First Row: First Name + Last Name */}
          <div className={classes.fieldRow}>
            <FormikTextField
              type="text"
              name="firstName"
              label={forms?.firstName || 'First Name'}
              backendError={backendErrors?.firstName}
              required
              autoFocus
              className={classes.halfWidth}
            />
            <FormikTextField
              type="text"
              name="lastName"
              label={forms?.lastName || 'Last Name'}
              backendError={backendErrors?.lastName}
              required
              className={classes.halfWidth}
            />
          </div>

          {/* Second Row: Email (Read-only) + Phone */}
          <div className={classes.fieldRow}>
            <div className={classes.emailFieldContainer}>
              <div className={classes.emailReadOnly}>
                <LockIcon className={classes.lockIcon} />
                <span className={classes.emailText}>
                  {createUserFlow.checkedEmail}
                </span>
                <CheckIcon className={classes.verifiedIcon} />
              </div>
            </div>
            <FormikTextField
              type='tel'
              name='phone'
              label={forms.phone || 'Phone Number'}
              backendError={backendErrors?.phone}
              placeholder="+1 (555) 123-4567"
              InputProps={{
                inputComponent: FormattedPhone,
              }}
              className={classes.halfWidth}
              // required
            />
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Step2UserDetails;
